// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ysOn","option":"styles_option__1BatG","selected":"styles_selected__1lL5l"};